import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { TierBadge } from "@/components/TierBadge";

// Testimonial wall (2026-02): impact stories the org pinned to their public
// page. Sits beside OrgVoices (aggregate ratings) — voices are short review
// excerpts, this is full first-person storytelling; both share the same
// white-card visual language. Renders nothing when the wall is empty.
export function OrgPinnedStories({ orgId }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.orgPinnedStories(orgId).then((d) => setItems(d?.items || [])).catch(() => {});
  }, [orgId]);
  if (!items.length) return null;
  return (
    <div data-testid="org-pinned-stories" className="bg-white border border-neutral-200 rounded-2xl p-6 mt-8">
      <div className="text-xs uppercase tracking-[0.18em] text-forest/70 font-bold">Volunteer stories</div>
      <p className="text-sm text-neutral-500 mt-1">First-person stories volunteers shared about their time here.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">
        {items.map((s) => (
          <figure key={s.id} data-testid={`org-pinned-story-${s.id}`} className="bg-cream/60 border border-forest/10 rounded-xl p-5">
            <blockquote className="text-sm text-neutral-700 leading-relaxed">“{s.text}”</blockquote>
            <figcaption className="mt-3 flex items-center justify-between gap-2 flex-wrap text-xs text-neutral-500">
              <span className="inline-flex items-center gap-1.5">
                <Link to={`/u/${s.user_id}`} className="font-medium text-forest hover:underline">{s.user_name}</Link>
                <TierBadge hours={s.author_total_hours} />
                <span>· {s.hours}h{s.opportunity_title ? ` · ${s.opportunity_title}` : ""}</span>
              </span>
              <Link to={`/stories?story=${s.id}`} data-testid={`org-pinned-story-link-${s.id}`} className="text-forest hover:underline shrink-0">
                Read on Stories
              </Link>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
}
